import { useTranslation } from "../../hooks";
import classes from "../../styles/History.module.css";
import { Fragment } from "react";

type ExtraInfoDataEntry = { key: string; text: string; values?: any[] };
type ExtraInfoContent = {
  info?: string;
  data: ExtraInfoDataEntry[];
};

const DataEntry: React.FC<{ entry: ExtraInfoDataEntry }> = ({ entry }) => {
  const values = entry.values ?? [];
  return (
    <Fragment>
      <div className={classes["extra-info-row"]}>
        <div className={classes["extra-info-key"]}>
          {useTranslation(entry.key)}
        </div>
        <div className={classes["extra-info-value"]}>
          {useTranslation(entry.text, ...values)}
        </div>
      </div>
    </Fragment>
  );
};

const ExtraInfo: React.FC<{ content: ExtraInfoContent | null }> = ({
  content,
}) => {
  const info = useTranslation(content?.info ?? "");
  if (!content) return null;

  return (
    <div className={classes["extra-info"]}>
      <div className={classes["extra-info-title"]}> {info} </div>
      <div className={classes["extra-info-data"]}>
        {content.data.map((entry, i) => (
          <DataEntry key={`data-entry-${i}`} entry={entry} />
        ))}
      </div>
    </div>
  );
};

export default ExtraInfo;
